import {Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {MatButtonToggle, MatButtonToggleChange} from "@angular/material/button-toggle";

@Component({
    selector: 'mbnm-builder-option',
    templateUrl: './option.component.html',
    styleUrls: ['./option.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OptionComponent implements OnInit {

  constructor() { }

  @Input()
  choices: Array<any>;

  @Output('selectionChanged')
  selectionChangedEventEmitter:EventEmitter<any> = new EventEmitter<any>(true);

  @Input()
  value:any;

  onChange(opt:MatButtonToggleChange) {
    this.value = opt.value;
    this.selectionChangedEventEmitter.emit(this.value);
  }

  ngOnInit() {

  }

  public lc(str:any) {
    if (str && typeof str == 'string') {
      str = str.toLowerCase();
    }
    return str;
  }
}
